"use client";

import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui/material";
interface StepConnectorProps {
  isCompleted: boolean;
}
export function StepConnector(t0) {
  const $ = _c(2);
  const {
    isCompleted
  } = t0;
  const t1 = isCompleted ? "-9px" : "0px";
  let t2;
  if ($[0] !== t1) {
    t2 = <Box sx={{
      marginTop: t1,
      marginX: "auto",
      width: "1px",
      backgroundColor: "#AFAFAF",
      height: "32px",
      justifySelf: "center"
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}